import { Badge } from '@/components/ui/badge'
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { useIsTruncated } from '@/hooks/use-is-truncated'
import { labelStatusTone } from '@/lib/labelStatus'
import { cn } from '@/lib/utils'

interface CallLabelBadgeProps {
  label: string | null | undefined
  category: string | null | undefined
}

/**
 * Colored label pill shared by the Calls table and the detail sheet.
 * Stays on a single line; when the label is truncated, hovering shows the
 * full value in a tooltip.
 */
export function CallLabelBadge({ label, category }: CallLabelBadgeProps) {
  const { ref, isTruncated } = useIsTruncated<HTMLSpanElement>()
  if (!label) return null

  const tone = labelStatusTone(category)
  return (
    <Tooltip>
      <TooltipTrigger disabled={!isTruncated} asChild>
        <Badge
          className={cn(
            'max-w-full rounded-md border-transparent',
            !isTruncated && 'pointer-events-none',
            tone.bg,
            tone.text
          )}>
          <span ref={ref} className="truncate">
            {label}
          </span>
        </Badge>
      </TooltipTrigger>
      <TooltipContent>{label}</TooltipContent>
    </Tooltip>
  )
}
